/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SelectableResourceService } from '@well/common-libs/selectable-resource-management/util';
import { EnvironmentService } from '@irian-ro/util-environment';
import { UnitMeasurementVO } from '@well/common-libs/unit-measurement/domain-model';

@Injectable({
  providedIn: 'root'
})
export class UnitMeasurementSelectableResourceService extends SelectableResourceService<UnitMeasurementVO> {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      `${environmentService.getEnvironmentProperty('unitMeasurementUrl')}/resource-list`,
      UnitMeasurementVO,
      true
    );
  }
}
